
  import { css } from 'lit';
  export const styles = css`:host{--pad-block: max(var(--is-large, 1) * max(0.75rem, -1 * 0.75rem), var(--is-medium, 1) * max(0.75rem, -1 * 0.75rem), var(--is-small, 1) * max(0.5rem, -1 * 0.5rem))}`;
  